import React from 'react';
import { AiChat } from './AiChat';

export const AiAssistant = ({ isOpen, onClose, embedded = false }) => {
    return (
        <AiChat
            isOpen={isOpen}
            onClose={onClose}
            isEmbedded={embedded}
        // Widget handles its own expansion state logic if needed, 
        // but for now we moved state inside Chat or we can hoist it back if required.
        // For widget, we let Chat handle expansion internally or pass props if we want parent control.
        // The original code had local state for expansion.
        />
    );
};
